import { RuntimeRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class NotificationsPresenter extends Base2Presenter {
  defaultActions = [
    { label: "Ok, Entendi", callback: () => this.onHideRequest() }
  ];

  initialState() {
    return {
      visible: false,
      type: "",
      content: "",
      title: "",
      actions: []
    };
  }

  async onStart() {
    this.subscribeTo(RuntimeRepository.props.notification, notification =>
      this.handleNotificationChange(notification)
    );

    this.router.transitionService.onEnter({}, transition => {
      if (
        transition.to().name === "app.login" &&
        transition.from().name !== "app.password-recovery"
      ) {
        this.onHideRequest();
      }
    });
  }

  handleNotificationChange(notification) {
    const { type, content, title, actions, onHide } = notification;

    this.enqueue({
      visible: true,
      type,
      content,
      onHide: onHide || (() => {})
    });

    if (type === "success") {
      this.enqueue({
        title: "",
        actions: []
      });
    } else {
      this.enqueue({
        title,
        actions: this.normalizeActions(actions || this.defaultActions)
      });
    }
  }

  onHideRequest() {
    this.enqueue({ visible: false });
    this.viewModel.onHide && this.viewModel.onHide();
  }

  normalizeActions(actions) {
    return actions.map(action => ({
      label: "",
      callback: () => {},
      ...action
    }));
  }
}

export default NotificationsPresenter;



// WEBPACK FOOTER //
// ./src/components/support/notifications/notifications.presenter.js